common.View.create('crud::form.inputs.Slug', {

    onDOMLoad() {
        this.initGui();
    },

    initGui() {
        // Data prepend on input?
        let dataPrepend = this.element.find('input').data('prepend');

        this.element.find('input').each((key, value) => {
            // Get current input value
            let $currentValue = $(value).val();

            // When user is typing
            $(document).on('keyup', 'input[name="' + $(value).data('trigger') + '"]', (event) => {
                this.changeValueToSlug(value, dataPrepend, $currentValue, event);
            });

            $(value).on('keyup', (event) => {
                this.changeValueToSlug(value, dataPrepend, $currentValue, event);
            });

            // When user is typing
            $(value, 'input[name="' + $(value).data('trigger') + '"]').on('blur', (event) => {
                $(value).val(event.currentTarget.value.replace(/\/$/g, ''));
            });

        });
    },

    changeValueToSlug(value, dataPrepend, $currentValue, event) {
        // when input is readonly and there is a value dont change slug
        if ($(value).prop('readonly') && $currentValue) {
            return;
        }

        // when not readonly allow slug to be changed
        if ($(event.currentTarget).prop('readonly') !== true) {
            let addVal = '';

            // Check if prepend is added, if so don't edit if user doesn't specifically does
            if (dataPrepend && !$(event.currentTarget).data('trigger')) {
                addVal = dataPrepend;
            }

            // Slugify value?
            $(value).data('slugify')
                ? $(value).val(addVal + this.slugify(event.currentTarget.value))
                : $(value).val(addVal + event.currentTarget.value);
        }
    },

    slugify(str) {
        str = str.replace(/^\s+|\s+$/g, '');

        // Make the string lowercase
        str = str.toLowerCase();

        // Remove dirs?
        if (!this.element.find('input').data('allow-dir')) {
            str = str.replace(/\//g, '-');
        }

        // Get trigger
        let triggerField = this.element.find('input').data('trigger');
        let triggerValue = $('input[name="'+triggerField+'"]').val().toLowerCase();

        // Remove accents, swap ñ for n, etc
        let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;&";
        let to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa-/-----";

        // Then handle triggerValue specific case
        if (triggerValue.includes('/')) {
            let triggerValueIndex = str.indexOf(triggerValue);
            if (triggerValueIndex !== -1) {
                while (triggerValue.includes('/')) {
                    let slashIndexInTriggerValue = triggerValue.indexOf('/');
                    let slashIndexInStr = triggerValueIndex + slashIndexInTriggerValue;
                    str = str.substring(0, slashIndexInStr) + '-' + str.substring(slashIndexInStr + 1);
                    triggerValue = triggerValue.substring(0, slashIndexInTriggerValue) + '-' + triggerValue.substring(slashIndexInTriggerValue + 1);
                }
            }
        }

        // Then handle the last slash in the string, if it's not part of triggerValue
        if (str.lastIndexOf('/') > str.indexOf(triggerValue) + triggerValue.length - 1) {
            let lastSlashIndex = str.lastIndexOf('/');
            str = str.substring(0, lastSlashIndex) + '-' + str.substring(lastSlashIndex + 1);
        }

        // Replace special chars on the end.
        for (let i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        // Remove invalid chars
        str = str.replace(/[^\w-\/ ]+/g, '')
            // Collapse whitespace and replace by -
            .replace(/\s+/g, '-')
            // Collapse dashes
            .replace(/-+/g, '-')
            // Replace multiple slashes
            .replace(/[/_,]+/g, '/')
            // And replace first and last slash with nothing
            .replace(/^\//g, '');

        $(this).val(str);

        return str;
    },
});
